import { MODAL_CLOSE } from "./types";



export const closeModal = () => {
  return {
    type: MODAL_CLOSE 
  };
}